<template>
  <v-btn
    v-if="actions.length"
    depressed
    color="primary"
    @click="openAction"
  >
    Podejmij działanie
  </v-btn>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('dkoCooperation', ['actions']),
  },
  methods: {
    ...mapActions('dialog', ['showDialog']),
    openAction() {
      this.showDialog({
        header: 'Potwierdzenie działania',
        text: 'Wybierz działanie dostępne dla bieżącej roli i statusu.',
        component: 'DkoCooperationAction',
        props: {
          width: 640,
          actions: this.actions,
        },
      });
    },
  },
};
</script>
